import React, { useRef } from "react";
import { Link } from "react-router-dom";
import {
  Checkbox,
  SelectListGroup,
  TextAreaGroup,
  TextFieldGroup,
} from "../../../common";
import * as style from "../styles.module.scss";
import { monthOptions, yearOptions } from "../../../helpers";

const WorkHistory = ({
  workHistoryState,
  workHistoryErrors,
  handleWorkHistoryState,
  handleSubmitWorkHistory,
  handleAddNewWorkHistory,
  handleRemoveWorkHistory,
  navigateBackPath,
  linkToCV,
}) => {
  const fieldRefs = useRef({});
  const handleFormSubmit = (e) => {
    e.preventDefault();
    handleSubmitWorkHistory(fieldRefs);
  };
  return (
    <form
      className={`col-sm-12 col-lg-6 mt-2 mt-lg-4 mb-2 ${style.form}`}
      onSubmit={handleFormSubmit}
    >
      <div>
        {Object.keys(workHistoryState).map((key) => (
          <div key={key} className={"mb-2"}>
            <div
              className="form-group"
              ref={(el) => {
                if (!fieldRefs.current[key]) fieldRefs.current[key] = {};
                fieldRefs.current[key].title = el;
              }}
            >
              <label htmlFor="title">Job title*</label>
              <TextFieldGroup
                value={workHistoryState[key].title}
                onChange={(e) => {
                  handleWorkHistoryState(key, "title", e.target.value);
                }}
                classes="register_field"
                validationMessages={workHistoryErrors[key]?.title}
                validationMessageIsRed
              />
            </div>
            <div
              className="form-group"
              ref={(el) => {
                if (!fieldRefs.current[key]) fieldRefs.current[key] = {};
                fieldRefs.current[key].title = el;
              }}
            >
              <label htmlFor="companyName">Company*</label>
              <TextFieldGroup
                value={workHistoryState[key].companyName}
                onChange={(e) => {
                  handleWorkHistoryState(key, "companyName", e.target.value);
                }}
                classes="register_field"
                validationMessages={workHistoryErrors[key]?.companyName}
                validationMessageIsRed
              />
            </div>
            <div className="form-group">
              <Checkbox
                name="currentlyWorkHere"
                isChecked={workHistoryState[key]?.currentlyWorkHere}
                onClick={(e) => {
                  handleWorkHistoryState(
                    key,
                    "currentlyWorkHere",
                    e.target.checked
                  );
                }}
                label={"I currently work here"}
              />
            </div>
            <div className="form-group">
              <label htmlFor="workHistoryFrom">From*</label>
              <div className="d-flex justify-content-between">
                <div
                  className="mr-1 w-100"
                  ref={(el) => {
                    if (!fieldRefs.current[key]) fieldRefs.current[key] = {};
                    fieldRefs.current[key].fromMonth = el;
                  }}
                >
                  <SelectListGroup
                    id="fromMonth"
                    classes="register_field register_field-dropdown"
                    options={monthOptions}
                    value={workHistoryState[key].fromMonth}
                    onChange={(e) => {
                      handleWorkHistoryState(key, "fromMonth", e.target.value);
                    }}
                    isError={workHistoryErrors[key].fromMonth}
                  />
                  {workHistoryErrors[key].fromMonth && (
                    <p
                      className="text_invalid fontSize-12"
                      style={{
                        color: "red",
                      }}
                    >
                      {workHistoryErrors[key].fromMonth[0]}
                    </p>
                  )}
                </div>
                <div
                  className="w-100"
                  ref={(el) => {
                    if (!fieldRefs.current[key]) fieldRefs.current[key] = {};
                    fieldRefs.current[key].fromYear = el;
                  }}
                >
                  <SelectListGroup
                    id="fromYear"
                    classes="register_field register_field-dropdown"
                    options={yearOptions}
                    value={workHistoryState[key].fromYear}
                    onChange={(e) => {
                      handleWorkHistoryState(key, "fromYear", e.target.value);
                    }}
                    isError={workHistoryErrors[key].fromYear}
                  />
                  {workHistoryErrors[key].fromYear && (
                    <p
                      className="text_invalid fontSize-12"
                      style={{
                        color: "red",
                      }}
                    >
                      {workHistoryErrors[key].fromYear[0]}
                    </p>
                  )}
                </div>
              </div>
            </div>
            {!workHistoryState[key].currentlyWorkHere && (
              <div className="form-group">
                <label htmlFor="workHistoryTo">To*</label>
                <div className="d-flex justify-content-between">
                  <div
                    className="mr-1 w-100"
                    ref={(el) => {
                      if (!fieldRefs.current[key]) fieldRefs.current[key] = {};
                      fieldRefs.current[key].toMonth = el;
                    }}
                  >
                    <SelectListGroup
                      id="toMonth"
                      classes="register_field register_field-dropdown mr-1"
                      options={monthOptions}
                      value={workHistoryState[key].toMonth}
                      onChange={(e) => {
                        handleWorkHistoryState(key, "toMonth", e.target.value);
                      }}
                      isError={workHistoryErrors[key].toMonth}
                    />
                    {workHistoryErrors[key].toMonth && (
                      <p
                        className="text_invalid fontSize-12"
                        style={{
                          color: "red",
                        }}
                      >
                        {workHistoryErrors[key].toMonth[0]}
                      </p>
                    )}
                  </div>
                  <div
                    className="w-100"
                    ref={(el) => {
                      if (!fieldRefs.current[key]) fieldRefs.current[key] = {};
                      fieldRefs.current[key].toYear = el;
                    }}
                  >
                    <SelectListGroup
                      id="toYear"
                      classes="register_field register_field-dropdown"
                      options={yearOptions}
                      value={workHistoryState[key].toYear}
                      onChange={(e) => {
                        handleWorkHistoryState(key, "toYear", e.target.value);
                      }}
                      isError={workHistoryErrors[key].toYear}
                    />
                    {workHistoryErrors[key].toYear && (
                      <p
                        className="text_invalid fontSize-12"
                        style={{
                          color: "red",
                        }}
                      >
                        {workHistoryErrors[key].toYear[0]}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <TextAreaGroup
                classes="register_field"
                value={workHistoryState[key].description}
                rows={5}
                onChange={(e) => {
                  handleWorkHistoryState(key, "description", e.target.value);
                }}
              />
            </div>
            {Object.keys(workHistoryState).length > 1 && (
              <p
                className={`${style.workHistory__link} pt-2 pb-3 border-bottom`}
                role="button"
                onClick={() => handleRemoveWorkHistory(key)}
              >
                Remove position
              </p>
            )}
          </div>
        ))}
        <div className="mb-3 mt-2">
          <button
            className="btn btn-outline-info text-dark col-12 col-sm-5"
            onClick={handleAddNewWorkHistory}
            type="button"
          >
            Add another position
          </button>
        </div>
        <div className={`mb-1 ${style.workHistory__link}`}>
          <Link to={linkToCV}>OR upload your CV</Link>
        </div>
      </div>
      <div className={`mt-4 mb-lg-2 ${style.actions}`}>
        <Link to={navigateBackPath}>
          <button className="btn btn-outline-info text-dark mr-1" type="button">
            Back
          </button>
        </Link>
        <button className="btn btn-primary btn-block" type="submit">
          Next
        </button>
      </div>
    </form>
  );
};

export default WorkHistory;
